import { render } from "./SatCatalogoGenericoView.vue?vue&type=template&id=96123c88&scoped=true"
import script from "./SatCatalogoGenericoView.vue?vue&type=script&lang=js"
export * from "./SatCatalogoGenericoView.vue?vue&type=script&lang=js"

import "./SatCatalogoGenericoView.vue?vue&type=style&index=0&id=96123c88&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96123c88"]])

export default __exports__